import { getLanguageBasedUrl, useDictionary } from 'lib/utils';
import { Text, Image, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import React, { useState } from 'react';
import classNames from 'classnames/bind';
import styles from './SeasonDetail.module.scss';
import type { SeasonDetails, ShowSeasonsProps } from 'models/podcasts-types';
import Button from 'components/helpers/Button/Button';
import ShortDescriptionFieldWrapper from 'components/helpers/ShortDescriptionFieldWrapper';

const cx = classNames.bind(styles);

const ShowSeasons: React.FC<ShowSeasonsProps> = (props) => {
  const { seasons, seasonsFallbackImage, titleHeadingLevel, titleTextStyle } = props;
  const listingItemHeadingLevelValue = 'h3';
  const numberToShowInitially = 5;
  const viewMoreCount = 5;
  const buttonMoreId = 'viewMore-button';
  const contentId = 'viewMore-content';
  const seasonsTitle = useDictionary('Seasons');
  const viewMoreLabel = useDictionary('View More');
  const { sitecoreContext } = useSitecoreContext();

  const [viewMore, setViewMore] = useState(false);
  const [displayCount, setDisplayCount] = useState<number>(numberToShowInitially);

  const handleViewMore = () => {
    setViewMore(true);

    const nextDisplayCount = displayCount + viewMoreCount;

    if (nextDisplayCount < seasons.length) {
      setDisplayCount(nextDisplayCount);
    } else {
      setDisplayCount(seasons.length);
    }
  };

  if (seasons?.length === 0) {
    return <></>;
  }

  return (
    <div className={cx('podcasts-show-seasons')}>
      <Text
        field={{ value: seasonsTitle }}
        tag={titleHeadingLevel || 'h2'}
        className={cx({ title: true, [titleTextStyle || 'font-style-xl']: true })}
      />
      <ul>
        {seasons?.slice(0, displayCount).map((item: SeasonDetails, index: number) => (
          <li key={index} className={cx('listing-card')}>
            <div className={cx('listing-image-column')}>
              <Image
                field={item.fields.photo.value?.src ? item.fields.photo : seasonsFallbackImage}
                className={cx('listing-image-column__image')}
              />
            </div>
            <div className={cx('blog-column')}>
              <a href={getLanguageBasedUrl(item.url, sitecoreContext.language)}>
                <Text
                  tag={listingItemHeadingLevelValue}
                  field={item.fields.seasonTitle}
                  className={cx('listing-card__link')}
                />
              </a>

              <ShortDescriptionFieldWrapper textField={item.fields.description} />
            </div>
          </li>
        ))}
      </ul>

      {seasons.length > displayCount && (
        <Button
          aria-controls={contentId}
          aria-expanded={viewMore}
          className={styles['viewButton']}
          id={buttonMoreId}
          onClick={handleViewMore}
          type="button"
        >
          {viewMoreLabel}
        </Button>
      )}
    </div>
  );
};

export default ShowSeasons;
